import { render } from "./AddReglementPage.vue?vue&type=template&id=81e544ba&ts=true"
import script from "./AddReglementPage.vue?vue&type=script&lang=ts"
export * from "./AddReglementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__